module.exports = __webpack_public_path__ + "static/media/sample-products-locale-csv.90e00908.csv";